import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-17 15:49:25
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-04-21 15:23:31
 * @Description: file content
 */
import React from 'react';

var EasErrorBoundary = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(EasErrorBoundary, _React$PureComponent);

  var _super = _createSuper(EasErrorBoundary);

  function EasErrorBoundary(props) {
    var _this;

    _classCallCheck(this, EasErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false,
      reloadable: false
    };
    return _this;
  }

  _createClass(EasErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return React.createElement("div", {
          className: "eas__error-boundary"
        }, React.createElement("div", {
          className: "error-boundary__title"
        }, this.state.message), this.state.reloadable && React.createElement("button", {
          className: "error-boundary__button",
          onClick: function onClick() {
            return window.location.reload();
          }
        }, "\u5237\u65B0\u91CD\u8BD5"));
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      var getMessage = function getMessage() {
        if (error.code === 404) return '404 NOT FOUND';
        if (/Loading.*failed/.test(error.message)) return '资源加载错误，请刷新重试';
        return error.message;
      };

      var message = getMessage();
      return {
        hasError: true,
        message: message,
        reloadable: /刷新/.test(message)
      };
    }
  }]);

  return EasErrorBoundary;
}(React.PureComponent);

export { EasErrorBoundary as default };